//import react from "react";
import { useTranslation } from "react-i18next";
import { Modal, OverlayBackdrop } from "@ds/ds-snam/react";
import { Button } from "@ds/ds-snam/react";
import { EntityType } from "shared/constants";
import { Textarea } from "@ds/ds-snam/react";


interface IDialogMessageProps{
    title:string,
    subtitle:string,
    textareaLabel:string,
    textAreaPlaceholder:string,
    textareaDescription:string,
    submitButtonLabel:string,
    icon:string,
    type:EntityType,
    onClick:(message:string)=>void,
    onClose:()=>void

}
const DialogMessage: React.FC<IDialogMessageProps> = (props): JSX.Element => {
    const {t} = useTranslation(['app']);

    //const [textValue,setTextValue] = useState('')
    let tempTextValue = ''; //TODO al posto di setTextValue
    const inputTextChange = (inputEvent: Event) => {
        //let text = (inputEvent as CustomEvent).detail.input.value;
        tempTextValue=(inputEvent as CustomEvent).detail.input.value;
        //setTextValue(text);
    }

    return (
        <>
        <div style={{ zIndex: 1200, position: "relative" }}>
            <OverlayBackdrop />
                <Modal 
                    modalSize="medium"
                    iconExtra={false}
                    overlayIcon="icon-open-mail"
                    overlayDescriptionId="overlay-description"
                    is-gradient-color={false}
                    onCloseModal={() =>
                        props.onClose()
                    }
                >
                    <div slot="title" style={{background:''}}>
                        <div style={{width:'fit-content',margin:'0 auto',color:'#db6100'}}>
                            <ds-icon
                                id="arrowTopBar"
                                icon="icon-megaphone"
                                icon-size="xlarge"
                                icon-filled="false"
                            ></ds-icon>
                        </div>
                    </div>
                    <div slot="title">
                        <h2 className="ff-ubuntu ff-title-s ff-bold" style={{ margin: "0 auto",width:'fit-content' }} id="overlay-title">
                            {props.title}
                        </h2>
                    </div>

                    <div slot="text" style={{marginTop:'20px'}}>
                        <p id="overlay-description" style={{background:'',margin:'0 auto',width:'fit-content',textAlign:'center',fontFamily:'Lato, Lato-local, sans-serif',fontSize:'16px',color:'#444C55'}}>
                            {props.subtitle}
                        </p>
                        
                    </div>
                    <div slot="text" style={{width:'80%',margin:'0 auto',marginTop:'20px'}}>
                        <Textarea
                            textareaLabel={props.textareaLabel}//"Descrizione mancata approvazione"
                            textareaName="rejectFormTextAreaDelegation"
                            textareaId="textareadelegationrejected-id"
                            elementResetPair=""
                            textareaDescription={props.textareaDescription}//"Caratteri"
                            textareaStatus="default"
                            textareaPlaceholder={props.textAreaPlaceholder}//"Inserisci qui la descrizione"
                            textareaMaxChar={500}
                            textareaRows={10}
                            isDisabled={false}
                            textAreaValue={tempTextValue}
                            isReadonly={false}
                            isExpandableVariant={false}
                            isEditableVariant={false}
                            showMaxChar={true}
                            onInputChange={inputTextChange}
                        ></Textarea>
                    </div>

                    <div
                        slot="footer"
                        style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "8px",
                        alignItems: "center",
                        marginTop:'20px'
                        }}
                    >
                        <div style={{margin:'0 auto',width:'fit-content'}}>
                            <Button
                                buttonType="button"
                                buttonUIVariant="primary"
                                buttonSize="medium"
                                buttonLabel={props.submitButtonLabel}//"Invia segnalazione"
                                buttonIcon=""
                                //isDisabled={!selectedContractId}
                                isDisabled={false}
                                buttonAriaLabel="insert customer button"
                                onClickEvent={() => {
                                    props.onClick(tempTextValue)
                                }}
                            ></Button>
                        </div>
                    </div>
                </Modal>
            </div>
        </>
    );
}

export default DialogMessage;